export const converterParaNumero = (valor) =>{
    if(valor === undefined || valor === null || valor === "") return 0

    if(typeof valor === "number") return valor;

    let texto = String(valor)

    texto = texto.replace("R$","").trim()
    texto = texto.replaceAll(".","");
    texto = texto.replace(",",".");

    let resultado = Number(texto) 

    return isNaN(resultado) ? 0: resultado;
}


export const juntarMoney = (totalDespesa,meses) =>{
//     3meses
// 6meses
// 9meses
// 12meses
// 15meses
// 18meses
// 21meses
// 24meses
console.log(converterParaNumero(totalDespesa))
console.log()
    let valor;
    switch (meses){
        case "3meses":
            valor = converterParaNumero(totalDespesa) * 3.0 
        break;
        case  "6meses":
            valor = converterParaNumero(totalDespesa) * 6.0 
        break;
        case "9meses":
            valor = converterParaNumero(totalDespesa) * 9.0 
        break;
        case "12meses":
            valor = converterParaNumero(totalDespesa) * 12.0 
        break;
        case "15meses":
            valor = converterParaNumero(totalDespesa) * 15.0 
        break;
        case "18meses":
            valor = converterParaNumero(totalDespesa) * 18.0 
        break;
        case "21meses":
            valor = converterParaNumero(totalDespesa) * 21.0 
        break;
        case "24meses":
            valor = converterParaNumero(totalDespesa) * 24.0 
        break;
        default: 
          valor = converterParaNumero(totalDespesa) * 3 

    }
    console.log("Aqui ta a informação" + valor)
    return valor.toFixed(2)
}

export const subtrair = (totalDespesa,totalReceita)=>{
    let saldo = Number(totalReceita) - Number(totalDespesa)
    return saldo 
}

export const conveterParaMonetario = (valor)=>{
    let v = Number(valor)
    let money = v.toLocaleString("pt-BR",{style:'currency',currency:'BRL'})
    return money
}

export const maskMoney = (value)=>{
    const valueClean = String(value).replace(/\D/g,"")

    if(!valueClean) return ""

    const valorNumero = Number(valueClean) / 100;

    return "R$ " + valorNumero.toLocaleString("pt-BR",{
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    })
}




